module.exports = __webpack_public_path__ + "media/images/illustration_2-2d78d3acf6dee5bd224d80330530cc7e.svg";